import window from 'window-or-global';
import { CONTEXT_PATH } from '@confluence-classic/confluence-urls';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import { getBrowserHistory } from '@confluence/browser-history';
import { getOverride, setOverride } from '@confluence/meta';
import { bind, trigger, unbind } from '@confluence-classic/confluence-event_DO_NOT_USE';
import { isDarkFeatureEnabled } from '../utils/dark-features-query-selector';

const plugin = () => {
	return {
		init: (ed) => {
			/*
             ASSUMPTIONS:
             - Confluence.Editor.Drafts global is ready; TODO: port confluence page-editor-drafts.js it has many friends
             - Confluence.Analytics global is ready;
             made available via wr!com.atlassian.confluence.editor:editor-autocomplete-resources-conf-frontend
             */
			const Drafts = window.Confluence.Editor.Drafts;
			const Editor = window.Confluence.Editor;

			let setIntervalId;

			function getPersistentQueryParams() {
				let queryStr = window.location.search;
				if (typeof queryStr === 'undefined') {
					return '';
				}

				if (queryStr.charAt(0) === '?') {
					queryStr = queryStr.substr(1);
				}
				return queryStr
					.split('&')
					.filter((param) => {
						return (
							// These are query parameters when we get from request access.
							// When user visits a restricted page, they can request access.
							// The content author will receive an email which they can click to grant user permission to view the page.
							// `username` and `userFullName` are deprecated in GDPR.
							// These should be removed once https://app.launchdarkly.com/confluence/production/features/confluence.gdpr.request.access/targeting is fully rolled out.
							param.indexOf('username=') === 0 ||
							param.indexOf('userFullName=') === 0 ||
							param.indexOf('accountId=') === 0 ||
							param.indexOf('displayName=') === 0 ||
							param.indexOf('accessType=') === 0 ||
							param.indexOf('grantAccess=') === 0 ||
							param.indexOf('atlOrigin=') === 0 ||
							param.indexOf('src.') === 0
						);
					})
					.join('&');
			}

			function sharedDraftsFeatures() {
				const browserHistory = getBrowserHistory();
				const setSharedDraftUrl = function (draftId, draftShareId) {
					// If a draft exists, replaceState with a shareable URL
					// Won't work for IE9 but that's ok as this is to temporary dogfood shared drafts technical milestone
					if (draftId !== 0) {
						// For React SPA we need to make sure we are staying in ReactRouter handled routes.
						// So we'll just add those get params to the
						if ($('#confluence-ui').length) {
							browserHistory.replace(
								`${
									window.location.pathname
								}?draftId=${draftId}&draftShareId=${draftShareId}&${getPersistentQueryParams()}`,
							);
						} else {
							// Using getOverride('base-url') may result in "DOMException: Failed to execute 'replaceState' on 'History'" when base-url differs from actual URL used to access Confluence.
							// Avoid setting the host to prevent it.
							browserHistory.replace(
								`${CONTEXT_PATH}/pages/resumedraft.action?draftId=${draftId}&draftShareId=${draftShareId}&${getPersistentQueryParams()}`,
							);
						}
					}
				};

				setSharedDraftUrl(getOverride('draft-id'), getOverride('draft-share-id'));

				Editor.UI.cancelButton.attr('data-tooltip', ed.translate('editor.shared.draft.done.desc'));
				Editor.UI.cancelButton.on('click', () => {
					trigger('analytics', {
						name: 'confluence.editor.done.button.clicked',
					});
					trigger('analytics', {
						name: 'confluence.editor.close',
						data: {
							source: 'closeButton',
							contentId: getOverride('content-id'),
							currentVersion: getOverride('page-version') || 'null',
						},
					});
				});
			}

			function addCurrentUserAsDraftCollaborator() {
				if (!getOverride('has-collaborated') && window.AJS.Rte.Content.editorHasContentChanged()) {
					setOverride('has-collaborated', true);
					const contentId = getOverride('content-id');

					$.ajax({
						type: 'PUT',
						url: `${CONTEXT_PATH}/rest/experimental/relation/collaborator/from/user/current/to/content/${contentId}?targetStatus=draft`,
						error() {
							setOverride('has-collaborated', false);
							if (process.env.NODE_ENV !== 'production') {
								console.error('Unable to store current user as a collaborator');
							}
						},
					});

					// Remove any touch relation on the published page
					// We don't really care if this fails since it should get cleaned up later anyway, so don't
					// do any error handling.
					$.ajax({
						type: 'DELETE',
						url: `${CONTEXT_PATH}/rest/experimental/relation/touched/from/user/current/to/content/${contentId}?targetStatus=current`,
					});

					// Add a touch relation to the draft
					$.ajax({
						type: 'PUT',
						url: `${CONTEXT_PATH}/rest/experimental/relation/touched/from/user/current/to/content/${contentId}?targetStatus=draft`,
						error() {
							setOverride('has-collaborated', false);
							if (process.env.NODE_ENV !== 'production') {
								console.error('Unable to store touch relation for current user');
							}
						},
					});
				}
			}

			const init = function (ed) {
				// eventually this plugin will be in charge of
				// creating the required UI and not just toggling visibility
				$('#draft-status').show();

				Drafts.bindUnloadMessage();
				Editor.UI.cancelButton.click(() => {
					// The save function checks whether the editor content has changed, and exits early otherwise.
					// This check is important because we don't want to override (by saving over) an existing draft
					// if the user left edit mode without resuming the draft or making any changes.
					Drafts.save({
						// Skip error handler because it shows a BRIGHT RED draft save ERROR due to the browser
						// cancelling in-flight ajax requests during page unload even if the server received the
						// draft request and saved it successfully but did not respond in time.
						skipErrorHandler: true,
					});
				});

				sharedDraftsFeatures(ed);

				return setInterval(Drafts.save, +getOverride('draft-save-interval') || 30000);
			};

			ed.on('Init', () => {
				if (isDarkFeatureEnabled('collaborative-audit-log')) {
					bind('editor.local.change', addCurrentUserAsDraftCollaborator);
				}
			});

			//CONFDEV-55148
			ed.on('Remove', () => {
				if (isDarkFeatureEnabled('collaborative-audit-log')) {
					unbind('editor.local.change', addCurrentUserAsDraftCollaborator);
				}
			});

			// ** PLEASE READ THIS **
			// Ideally, we want to use the tinymce plugin interface (onInit, onRemove) to start and teardown the plugin.
			// We have some problems that we need to address first though:
			// - Editor.UI is not bound yet on ed.onInit yet (what happens on init.rte), so
			// we need to rely on AJS.bind instead, which gets triggered much after.
			// TODO: this needs to be fixed.

			//ed.onInit.add(function(){ // this is the correct way of doing it that we should use in the future. See comment above.
			bind('rte-ready', () => {
				if (process.env.NODE_ENV !== 'production') {
					console.info('confluence drafts plugin initialisation');
				}
				setIntervalId = init(ed);
			});

			//ed.onRemove.add(function(){ // this is the correct way of doing it that we should use in the future. See comment above.
			bind('rte-destroyed', () => {
				if (process.env.NODE_ENV !== 'production') {
					console.info('confluence drafts plugin tear down');
				}
				clearInterval(setIntervalId);
			});
		},

		getInfo: () => {
			return {
				longname: 'Confluence Drafts',
				author: 'Atlassian',
				authorurl: 'http://www.atlassian.com',
				version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
			};
		},
	};
};

export default function confluenceDrafts() {
	window.tinymce.create('tinymce.plugins.ConfluenceDrafts', plugin());
	window.tinymce.PluginManager.add('confluencedrafts', window.tinymce.plugins.ConfluenceDrafts);
}
